import React from 'react';
import { Text1 } from '../../../styles';


const LedgerHeader = (props) => {
    return (
        <div className="leader-info-header-wrapper">
            <div className="mb-1">
                <Text1 strong>
                    {props.ledger.unique_transaction_reference || "--"}
                </Text1>
            </div>
        </div>
    )
}

export { LedgerHeader };